
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies-portfolio",
      function () {
        return require("private-next-pages/companies-portfolio/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/companies-portfolio"])
      });
    }
  